import { render, staticRenderFns } from "./edit-mainlandorde.vue?vue&type=template&id=327a4464"
import script from "./edit-mainlandorde.vue?vue&type=script&lang=ts"
export * from "./edit-mainlandorde.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports